import {Stack} from "@mui/material";
import type {CharacterResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, OperatorToggle, F, SummaryPill, SummaryPillRow, rowSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function CharacterEditor({draft, editing, onChange}: ResolverEditorProps & { draft: CharacterResolver }) {
    if (!editing) {
        return (
            <SummaryPillRow>
                <SummaryPill label="Operator" value={draft.operator}/>
                <SummaryPill label="Value" value={draft.value}/>
            </SummaryPillRow>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <OperatorToggle
                    value={draft.operator}
                    options={[
                        {label: "Contains", value: "CONTAINS"},
                        {label: "Starts", value: "STARTS"},
                        {label: "Ends", value: "ENDS"},
                    ]}
                    onChange={(v) => upd("operator", v)}
                />
                <F value={draft.value} placeholder="Value" onChange={(v) => upd("value", v)} width="200px"/>
            </Stack>
        </Stack>
    );
}

export default CharacterEditor;
